import { IConstraintProvenUndrilledObligation } from '../../interfaces/iconstraint-proven-undrilled-obligation';
import { Area } from '../area';
import { AreaType } from '../area-type';
import { Scenario } from '../scenario';

export class ConstraintProvenUndrilledObligationBase {
  ConstraintProvenUndrilledObligationId: number;
  ScenarioId: number;
  AreaId: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintProvenUndrilledObligation) {
    if (item) {

      this.ConstraintProvenUndrilledObligationId = item.ConstraintProvenUndrilledObligationId;
      this.ScenarioId = item.ScenarioId;
      this.AreaId = item.AreaId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}